import { OneStemBrand } from '@/components/brand/OneStemBrand'
import { Link } from '@tanstack/react-router'
import { Button } from './ui/button'
import { Card, CardContent } from './ui/card'
import { Typography } from '@/components/ui/typography'
import { useAuthState } from '@/lib/services/auth/auth.query'

export default function Default404() {
  const { data: { user } = {} } = useAuthState()
  // Router-level not-found UI can render outside PathHelperProvider.
  const destination = user?.organization_id ? `/${user.organization_id}/admin` : '/login'

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <Card className="w-full max-w-lg text-center">
        <CardContent className="flex flex-col items-center gap-4 px-6 py-10">
          <OneStemBrand variant="icon" className="size-14" decorative />
          <Typography variant="h1" className="pb-0">
            404
          </Typography>
          <div className="space-y-2">
            <Typography variant="h3" className="pb-0">
              We couldn&apos;t find that page.
            </Typography>
            <Typography variant="supporting" className="block">
              The page may have moved, or you may not have access to it.
            </Typography>
          </div>
          <Button asChild>
            <Link to={destination}>
              {user?.organization_id ? 'Go to dashboard' : 'Go to login'}
            </Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  )
}
